import searchController from './controllers/searchController';
import jackpotsComponentsController from './controllers/jackpotsComponentsController';

const mainConfig = {
  id: 'root',
  context: {
    splashPageVisible: true,
    games: {},
    shuffleGames: {
      status: null,
      availableList: [],
      drawnList: [],
      drawnGame: null,
    },
    strikeGoldData: {
      awardedToday: null,
      awardedEver: null,
    },
    rpVisible: true,
    searchRpVisible: true,
    rpFirstLoad: true,
    user: {
      loggedIn: false,
      userCurrency: '',
      userAccountNumber: '',
      userStatus: 'non-customer',
      userToken: '',
    },
    loginModalState: {
      isOpened: false,
      isAwaitingLogin: false,
    },
    gameToLaunch: null,
    isGameModalForMobileOpened: false,
    pendingAccountEvents: [],
    controllersData: {},
  },
  initial: 'checkingForRedirection',
  states: {
    checkingForRedirection: {
      always: [
        {
          cond: 'shouldRedirectUrl',
          target: 'redirecting',
        },
        {
          target: 'main',
        },
      ],
    },
    redirecting: {
      type: 'atomic',
      invoke: {
        src: 'redirectUrl',
        onDone: {
          target: 'main',
        },
        onError: {
          target: 'main',
        },
      },
    },
    main: {
      type: 'parallel',
      states: {
        session: {
          invoke: {
            src: 'watchSession',
          },
          initial: 'initializing',
          states: {
            initializing: {
              on: {
                SESSION_STATE_LOGGED_IN: {
                  target: 'userLoggedIn',
                  actions: [
                    {
                      type: 'save',
                      data: {
                        user: '$event.data',
                        sessionResolved: true,
                      },
                      meta: {
                        selectors: ['$action.data.user'],
                      },
                    },
                  ],
                },
                SESSION_STATE_LOGGED_OUT: {
                  target: 'userLoggedOut',
                  actions: [
                    {
                      type: 'save',
                      data: {
                        user: '$event.data',
                        sessionResolved: true,
                      },
                      meta: {
                        selectors: ['$action.data.user'],
                      },
                    },
                  ],
                },
              },
            },
            userLoggedOut: {
              entry: ['manageGameLaunchCallbackMode', 'renderBingoGames'],
              invoke: {
                src: 'setCallbackModeForComponents',
                onDone: {
                  actions: [
                    {
                      type: 'batchLayoutOperations',
                      data: '$event.data.updates',
                      meta: {
                        selectors: ['$action.data'],
                      },
                    },
                  ],
                },
              },
              on: {
                SESSION_STATE_LOGGED_IN: {
                  target: 'userLoggedIn',
                  actions: [
                    {
                      type: 'save',
                      data: {
                        user: '$event.data',
                      },
                      meta: {
                        selectors: ['$action.data.user'],
                      },
                    },
                  ],
                },
              },
            },
            userLoggedIn: {
              type: 'parallel',
              entry: 'renderBingoGames',
              states: {
                manageUserRelatedContent: {
                  entry: 'updateUserTrackingInfo',
                  initial: 'fetchPageForLoggedInUser',
                  states: {
                    fetchPageForLoggedInUser: {
                      always: [
                        {
                          target: 'fetchAuthToken',
                          cond: 'isAppInitilaized_InternalTokenVariant',
                        },
                        {
                          target: 'idle',
                        },
                      ],
                    },
                    fetchAuthToken: {
                      invoke: {
                        src: 'fetchAuthToken',
                        onDone: [
                          {
                            target: 'updateAuthData',
                            actions: ['saveAuthToken'],
                          },
                        ],
                      },
                    },
                    updateAuthData: {
                      always: [
                        {
                          target: 'idle',
                          actions: [
                            { type: 'save', data: { initialRequest: true } },
                            'layout_changePageId',
                          ],
                          cond: 'areAnySavedSegments',
                        },
                        {
                          target: 'idle',
                          actions: [
                            'categories_refetch',
                            'categories_reload',
                            'layout_reload',
                            'layout_changePageId',
                          ],
                          cond: 'isDifferentCurrency',
                        },
                        {
                          target: 'idle',
                          actions: ['layout_reload', 'layout_changePageId'],
                          cond: 'arePersonalizedBannersAvailable',
                        },
                        {
                          target: 'idle',
                          actions: [
                            'layout_reload',
                            'layout_changePageId',
                            'saveInfoAccountInfo',
                            'trackPendingAccountEvents',
                          ],
                        },
                      ],
                    },
                    idle: {
                      entry: 'manageGameLaunchCallbackMode',
                      invoke: {
                        src: 'setCallbackModeForComponents',
                        onDone: [
                          {
                            target: 'watchSessionRelatedEvents',
                            actions: [
                              {
                                type: 'batchLayoutOperations',
                                data: '$event.data.updates',
                                meta: {
                                  selectors: ['$action.data'],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    watchSessionRelatedEvents: {
                      entry: ['fetchRecentlyPlayed'],
                      invoke: [{ src: 'watchSessionTokenExpirationTime' }],
                      initial: 'idle',
                      states: {
                        idle: {
                          on: {
                            REFRESH_SESSION_TOKEN: [
                              {
                                actions: ['fetchRefreshedSessionToken'],
                                cond: 'isInternalAuthTokenVariant',
                              },
                              {
                                actions: ['saveRefreshedAuthToken'],
                              },
                            ],
                            SESSION_STATE_LOGGED_OUT: [
                              {
                                cond: 'currentlyOnRecentlyPlayedPage',
                                target: '#root.main.session.userLoggedOut',
                                actions: [
                                  {
                                    type: 'savePreviousUser',
                                  },
                                  {
                                    type: 'save',
                                    data: {
                                      user: '$event.data',
                                    },
                                    meta: {
                                      selectors: ['$action.data.user'],
                                    },
                                  },
                                  'rp_rerender',
                                ],
                              },
                              {
                                cond: 'arePersonalizedBannersAvailable',
                                target: '#root.main.session.userLoggedOut',
                                actions: [
                                  {
                                    type: 'savePreviousUser',
                                  },
                                  {
                                    type: 'save',
                                    data: {
                                      user: '$event.data',
                                    },
                                    meta: {
                                      selectors: ['$action.data.user'],
                                    },
                                  },
                                  'layout_changePageId',
                                  'rp_rerender',
                                ],
                              },
                              {
                                cond: 'isDifferentCurrency',
                                target: '#root.main.session.userLoggedOut',
                                actions: [
                                  {
                                    type: 'savePreviousUser',
                                  },
                                  {
                                    type: 'save',
                                    data: {
                                      user: '$event.data',
                                    },
                                    meta: {
                                      selectors: ['$action.data.user'],
                                    },
                                  },
                                  'layout_changePageId',
                                  'rp_rerender',
                                ],
                              },
                              {
                                target: '#root.main.session.userLoggedOut',
                                actions: [
                                  {
                                    type: 'savePreviousUser',
                                  },
                                  {
                                    type: 'save',
                                    data: {
                                      user: '$event.data',
                                    },
                                    meta: {
                                      selectors: ['$action.data.user'],
                                    },
                                  },
                                  'layout_reload',
                                  'rp_rerender',
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
                managePhrases: {
                  initial: 'idle',
                  states: {
                    idle: {
                      always: [
                        {
                          target: 'addPendingPhraseToRecentPhrases',
                          cond: 'isPhrasePendingToAddToRecentPhrases',
                        },
                      ],
                    },
                    addPendingPhraseToRecentPhrases: {
                      invoke: {
                        src: 'fetchRecentPhrases',
                        onDone: {
                          actions: [
                            {
                              type: 'save',
                              data: {
                                recentPhrases: '$event.data.recentPhrases',
                              },
                              meta: {
                                selectors: ['$action.data.recentPhrases'],
                              },
                            },
                            {
                              type: 'updatePhrases',
                            },
                            {
                              type: 'savePhrase',
                            },
                          ],
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
        watchSessionToken: {
          initial: 'init',
          states: {
            init: {
              on: {
                FETCH_AUTH_TOKEN: {
                  target: 'fetchNewAuthToken',
                },
                FETCH_REFRESHED_AUTH_TOKEN: {
                  target: 'fetchRefreshedAuthToken',
                },
                FETCH_REFRESHED_AUTH_TOKEN_WITH_DEPENDENCIES: {
                  target: 'fetchRefreshedAuthTokenWithDependencies',
                },
              },
            },
            fetchNewAuthToken: {
              invoke: {
                src: 'fetchAuthToken',
                onDone: [
                  {
                    target: 'init',
                    actions: ['saveAuthToken'],
                  },
                ],
              },
            },
            fetchRefreshedAuthToken: {
              invoke: {
                src: 'fetchRefreshedAuthToken',
                onDone: [
                  {
                    target: 'init',
                    actions: 'fetchAuthToken',
                    cond: 'isAuthTokenExpired',
                  },
                  {
                    target: 'init',
                    actions: ['saveRefreshedAuthToken'],
                  },
                ],
              },
            },
            fetchRefreshedAuthTokenWithDependencies: {
              invoke: {
                src: 'fetchRefreshedAuthToken',
                onDone: [
                  {
                    target: 'init',
                    actions: ['saveRefreshedAuthToken', 'fetchRecentlyPlayed'],
                    cond: 'isAuthTokenInitialSetup',
                  },
                  {
                    target: 'init',
                    actions: ['saveRefreshedAuthToken', 'fetchRecentlyPlayed'],
                  },
                ],
              },
            },
          },
        },
        watchJackpotsV2: {
          initial: 'init',
          states: {
            init: {
              on: {
                GET_RECENTLY_PLAYED_JACKPOTSV2: {
                  target: 'getRecentlyPlayedJackpotsV2',
                },
                GET_JACKPOTSV2: {
                  target: 'getJackpotsV2',
                },
                REFETCH_STALE_JACKPOTSV2: {
                  target: 'refetchStaleJackpotsV2',
                },
                GET_SEARCH_GAMES_JACKPOTVS2: {
                  target: 'getJackpotsV2ForSearchGames',
                },
              },
            },
            getJackpotsV2: {
              invoke: {
                src: 'getJackpotsV2',
                onDone: {
                  actions: ['updateJackpotsV2', 'categories_reload'],
                  target: 'init',
                },
              },
            },
            getRecentlyPlayedJackpotsV2: {
              invoke: {
                src: 'getRecentlyPlayedJackpotsV2',
                onDone: [
                  {
                    target: 'init',
                    actions: ['updateJackpotsV2', 'rp_rerender'],
                  },
                ],
              },
            },
            refetchStaleJackpotsV2: {
              invoke: {
                src: 'refetchStaleJackpots',
                onDone: [
                  {
                    actions: ['updateJackpotsV2', 'categories_reload'],
                    target: 'init',
                    cond: 'isJackpotsDataChanged',
                  },
                  {
                    actions: ['updateJackpotsV2'],
                    target: 'init',
                    cond: 'isJackpotsDataUpdated',
                  },
                  { target: 'init' },
                ],
              },
            },
            getJackpotsV2ForSearchGames: {
              invoke: {
                src: 'getJackpotsV2ForSearchGames',
                onDone: {
                  actions: ['updateJackpotsV2', 'search_items_reload'],
                  target: 'init',
                },
              },
            },
          },
        },
        watchRecentlyPlayed: {
          initial: 'init',
          states: {
            init: {
              on: {
                UPDATE_RECENTLY_PLAYED: {
                  target: 'updateRecentlyPlayed',
                },
                UPDATE_RECENTLY_PLAYED_AFTER_DELAY: {
                  target: 'updateRecentlyPlayedAfterDelay',
                },
                CLEAR_RECENTLY_PLAYED: {
                  target: 'clearRecentlyPlayed',
                },
              },
            },
            updateRecentlyPlayedAfterDelay: {
              invoke: {
                src: 'watchRecentlyPlayedTimer',
              },
              on: {
                RECENTLY_PLAYED_TO_UPDATE: {
                  target: 'updateRecentlyPlayed',
                },
              },
            },
            updateRecentlyPlayed: {
              invoke: {
                src: 'fetchRecentlyPlayedGames',
                onDone: [
                  {
                    target: 'init',
                    actions: ['initAuthTokenRefresh', 'updateRetryStatus'],
                    cond: 'isResponseInvalid_InternalAuthTokenVariant',
                  },
                  {
                    target: 'init',
                    actions: [
                      'updateRecentlyPlayedGames',
                      'rp_rerender',
                      'getRecentlyPlayedJackpotV2',
                    ],
                  },
                ],
              },
            },
            clearRecentlyPlayed: {
              always: {
                target: 'init',
                actions: ['clearRecentlyPlayedGames', 'rp_rerender'],
              },
            },
          },
        },
        watchUserAction: {
          invoke: {
            src: 'watchUserAction',
          },
        },
        loginModal: {
          invoke: {
            src: 'watchLoginModalActions',
            cond: 'isHeaderInVisibleMode',
          },
          on: {
            LOGIN_MODAL_STATE_AWAIT_LOGIN: {
              actions: [
                {
                  type: 'save',
                  data: {
                    loginModalState: {
                      isAwaitingLogin: true,
                    },
                  },
                },
              ],
            },
            SESSION_STATE_LOGGED_IN: {
              actions: [
                {
                  type: 'save',
                  data: {
                    loginModalState: {
                      isAwaitingLogin: false,
                    },
                  },
                },
              ],
            },
            SESSION_STATE_LOGGED_OUT: {
              actions: [
                {
                  type: 'save',
                  data: {
                    isAccountInfoAvailable: false,
                  },
                },
              ],
            },
          },
        },
        registrationModal: {
          invoke: {
            src: 'watchRegisterModalActions',
            cond: 'isHeaderInVisibleMode',
          },
        },
        depositModal: {
          invoke: {
            src: 'watchDepositModalCloseAction',
            cond: 'isHeaderInVisibleMode',
          },
        },
        launchingRouteDynamicActionController: {
          initial: 'idle',
          states: {
            idle: {
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'transient',
                  cond: 'isRouteDynamicAction',
                },
              },
            },
            transient: {
              always: [
                {
                  target: 'waitingForSession',
                  cond: 'isSessionNotResolved',
                },
                {
                  target: 'setRouteDynamicAction',
                },
              ],
            },
            waitingForSession: {
              on: {
                SESSION_STATE_LOGGED_OUT: 'setRouteDynamicAction',
                SESSION_STATE_LOGGED_IN: 'setRouteDynamicAction',
              },
            },
            setRouteDynamicAction: {
              invoke: {
                src: 'setRouteDynamicActionData',
                onDone: {
                  target: 'launchRouteDynamicAction',
                  actions: {
                    type: 'save',
                    data: {
                      routeDynamicAction: '$event.data.routeDynamicAction',
                    },
                    meta: {
                      selectors: ['$action.data.routeDynamicAction'],
                    },
                  },
                },
              },
            },
            launchRouteDynamicAction: {
              always: [
                {
                  target: 'loggedInRouteDynamicAction',
                  cond: 'isLoggedInStateRequiredForRouteDynamicAction',
                },
                {
                  target: 'loggedOutRouteDynamicAction',
                  cond: 'isLoggedOutStateRequiredForRouteDynamicAction',
                },
              ],
            },
            loggedOutRouteDynamicAction: {
              always: [
                {
                  target: 'performAction',
                  cond: 'isLoggedOut',
                },
                {
                  target: 'redirectToMainPage',
                  cond: 'isLoggedIn',
                },
              ],
            },
            loggedInRouteDynamicAction: {
              always: [
                {
                  target: 'performAction',
                  cond: 'isLoggedIn',
                },
                {
                  target: 'performActionWithLogin',
                  cond: 'isLoggedOut',
                },
              ],
            },
            performActionWithLogin: {
              invoke: {
                src: 'launchLogin',
              },
              on: {
                SESSION_STATE_LOGGED_IN: 'waitForLayoutChangeEnd',
                LOGIN_MODAL_STATE_CLOSED: [
                  {
                    target: 'redirectToMainPage',
                    cond: 'isNotAwaitingLogin',
                  },
                ],
              },
            },
            waitForLayoutChangeEnd: {
              on: {
                LAYOUT_CHANGE_END: 'performAction',
              },
            },
            performAction: {
              invoke: {
                src: 'performRouteDynamicAction',
              },
              on: {
                REGISTER_MODAL_STATE_CLOSED: 'redirectToMainPage',
                DEPOSIT_MODAL_STATE_CLOSED: 'redirectToMainPage',
              },
              onDone: {
                target: 'stop',
              },
            },
            redirectToMainPage: {
              invoke: {
                src: 'redirectToMainPage',
              },
              onDone: {
                target: 'stop',
              },
            },
            stop: {
              type: 'final',
            },
          },
        },
        launchingGameController: {
          initial: 'idle',
          invoke: [{ src: 'watchGameActions' }],
          states: {
            idle: {
              always: [
                {
                  target: 'initGameLauncherCommunication',
                },
              ],
            },
            initGameLauncherCommunication: {
              invoke: {
                src: 'initializeGameFrameBridge',
                onDone: {
                  target: 'initGameLaunchObserver',
                },
              },
            },
            initGameLaunchObserver: {
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'runGameFromDirectLink',
                  cond: 'isControllerEnabled_gameLauncher',
                },
                LAYOUT_PAGEID_CHANGE: {
                  actions: [
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Layout.properties.gameModalOpen',
                        value: false,
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                  ],
                },
                PROMOTIONS_GAME_OPEN_CLICK: {
                  target: 'fetchGameLaunch',
                },
                VIEW_CATEGORY_GAME_TILE_CLICK: [
                  {
                    target: 'transient',
                    actions: 'trackSearchGameClick',
                    cond: 'isGameLaunchedFromSearchCategory',
                  },
                  {
                    target: 'transient',
                    actions: 'trackGameClick',
                  },
                ],
                VIEW_BOTTOM_MENU_GAME_CLICK: {
                  target: 'transient',
                  actions: 'trackGameClick',
                },
                VIEW_SIDE_MENU_GAME_CLICK: {
                  target: 'transient',
                  actions: ['trackGameClick'],
                },
                VIEW_GAME_DETAILS_BUTTON_CLICK: [
                  {
                    target: 'transient',
                    actions: 'trackGameClick',
                  },
                ],
                TREBUCHET_PARTIAL_EVENT_CALLED: {
                  actions: 'trackTrebuchetPartialEvent',
                },
                VIEW_SUGGESTED_GAMES_TILE_CLICK: [
                  {
                    target: 'fetchGameLaunch',
                    actions: [
                      {
                        type: 'save',
                        data: {
                          clickedOnSuggestedGame: true,
                        },
                      },
                    ],
                  },
                ],
                VIEW_FULL_SCREEN_OVERLAY_CLICK: {
                  actions: ['handleFullScreenOverlayClick'],
                },
                GAME_SWITCHED: {
                  target: 'fetchGameLaunch',
                  actions: [{ type: 'save', data: { isSwitchingGame: true } }],
                },
                GAME_LAUNCH_REQUESTED: {
                  target: 'fetchGameLaunch',
                  actions: [
                    { type: 'save', data: { isLaunchedFromLauncher: true } },
                  ],
                },
              },
            },
            runGameFromDirectLink: {
              invoke: {
                src: 'runGameFromDirectLink',
                onDone: [
                  { target: 'transient', cond: 'shouldRunTheGame' },
                  {
                    target: 'initGameLaunchObserver',
                    actions: [
                      {
                        type: 'save',
                        data: {
                          currentPagePath: '/',
                        },
                      },
                      'updateUrl',
                    ],
                  },
                ],
              },
            },
            transient: {
              always: [
                {
                  target: 'waitingForSession',
                  cond: 'isSessionNotResolved',
                },
                { target: 'setGameToLaunch' },
              ],
            },
            waitingForSession: {
              on: {
                SESSION_STATE_LOGGED_OUT: 'setGameToLaunch',
                SESSION_STATE_LOGGED_IN: 'waitForLayoutChangeTwo',
              },
            },
            waitForLayoutChangeTwo: {
              on: {
                LAYOUT_CHANGE_END: [
                  {
                    target: 'setGameToLaunch',
                  },
                ],
              },
            },
            fetchGameLaunch: {
              invoke: {
                src: 'fetchGameToLaunch',
                onDone: [
                  {
                    cond: 'isGameFetched',
                    target: 'setGameToLaunch',
                  },
                  {
                    target: 'initGameLaunchObserver',
                    actions: ['gameFetchFailed'],
                  },
                ],
                onError: {
                  target: 'initGameLaunchObserver',
                  actions: ['layout_openSystemErrorPage'],
                },
              },
            },
            setGameToLaunch: {
              invoke: {
                src: 'setGameToLaunchData',
                onDone: {
                  target: 'trackGameClickedFromLauncher',
                  actions: {
                    type: 'save',
                    data: {
                      gameToLaunch: '$event.data.gameToLaunch',
                    },
                    meta: {
                      selectors: ['$action.data.gameToLaunch'],
                    },
                  },
                },
              },
            },
            trackGameClickedFromLauncher: {
              always: [
                {
                  target: 'initLaunchGameFlow',
                  actions: [
                    'setSuggestedGameUrl',
                    'trackGameClickFromLauncher',
                    'removeLastPagePath',
                  ],
                  cond: 'isClickedSuggestedGame',
                },
                {
                  target: 'initLaunchGameFlow',
                  actions: ['trackGameClickFromLauncher'],
                  cond: 'isLaunchedFromLauncher',
                },
                {
                  target: 'initLaunchGameFlow',
                },
              ],
            },
            initLaunchGameFlow: {
              always: [
                {
                  target: 'launchingGameWithLogin',
                  cond: 'isNotAllowedToLaunchGame',
                },
                {
                  cond: 'isSwitchingGame',
                  target: 'switchGame',
                },
                {
                  cond: 'isNewWindowStrategy', // do nothing, already handled in component due to popup blockers
                  target: 'initGameLaunchObserver',
                },
                {
                  actions: 'openGameInCurrentTab',
                  cond: 'isModalForMobileNotSupported',
                  target: 'launchGame',
                },
                {
                  target: 'launchGameInModal',
                  cond: 'isLaunchGameInModal',
                },
                {
                  target: 'launchGame',
                  cond: 'isGameTriggeredByUserInteraction',
                },
                {
                  target: 'openGameDetailsPage',
                  actions: 'removeGameLaunchController',
                },
              ],
            },
            launchingGameWithLogin: {
              invoke: {
                src: 'launchLogin',
              },
              on: {
                SESSION_STATE_LOGGED_IN: 'waitForLayoutChangeEnd',
                LOGIN_MODAL_STATE_CLOSED: [
                  {
                    target: 'initGameLaunchObserver',
                    cond: 'isNotAwaitingLogin',
                  },
                ],
              },
            },
            waitForLayoutChangeEnd: {
              on: {
                LAYOUT_CHANGE_END: [
                  {
                    target: 'openGameDetailsPage',
                    cond: 'isNewWindowStrategy',
                  },
                  {
                    target: 'launchGameInModal',
                    cond: 'isLaunchGameInModal',
                  },
                  {
                    target: 'initGameLaunchObserver',
                    cond: 'isGameDetailsPage',
                  },
                  {
                    target: 'openGameDetailsPage',
                  },
                ],
              },
            },
            openGameDetailsPage: {
              always: [
                {
                  actions: ['removeLastPagePath', 'gameDetails_open'],
                  target: 'initGameLaunchObserver',
                  cond: 'isOnLaunchPathAlready',
                },
                {
                  actions: ['gameDetails_open'],
                  target: 'initGameLaunchObserver',
                },
              ],
            },
            switchGame: {
              entry: [
                { type: 'save', data: { isSwitchingGame: false } },
                'updateGameLaunchedTracking',
                'fetchRecentlyPlayedAfterDelay',
              ],
              always: 'initGameLaunchObserver',
            },
            launchGameInModal: {
              entry: [
                'hideMyAccountDropdown',
                'hideBalance',
                'setStatusGameModalForMobile',
                {
                  type: 'save',
                  data: {
                    clickedOnSuggestedGame: false,
                  },
                },
                {
                  type: 'batchLayoutOperations',
                  data: [
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.GameModal.properties.game',
                        value: '$context.gameToLaunch',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Modal.properties.componentVisible',
                        value: false,
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.GameModal.properties.user',
                        value: '$context.user',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.GameModal.properties.isFullScreen',
                        value: '$context.isFullScreen',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Category.properties.visible',
                        value: false,
                      },
                    },
                  ],
                },
                'gameModal_open',
                'fetchRecentlyPlayedAfterDelay',
                'categories_reload',
                'rp_rerender',
              ],
              always: 'initGameLaunchObserver',
            },
            launchGame: {
              always: {
                target: 'initGameLaunchObserver',
                actions: [
                  'fetchRecentlyPlayedAfterDelay',
                  {
                    type: 'save',
                    data: {
                      clickedOnSuggestedGame: false,
                    },
                  },
                  {
                    type: 'save',
                    data: {
                      gameToLaunch: null,
                    },
                  },
                ],
              },
            },
          },
        },
        launchingSelfExclusion: {
          initial: 'idle',
          states: {
            idle: {
              on: {
                VIEW_SELF_EXCLUSION_BUTTON_CLICK: {
                  target: 'openSelfExclusion',
                },
              },
            },
            openSelfExclusion: {
              entry: 'openSelfExclusion',
              always: 'idle',
            },
          },
        },
        header: {
          invoke: {
            src: 'watchHeaderActions',
          },
          initial: 'idle',
          states: {
            idle: {
              on: {
                WH_HEADER_INITIALIZED: {
                  actions: 'setHeaderInitialized',
                },
                VIEW_PARTIAL_EVENT_CALLED: {
                  actions: 'trackPartialEvent',
                },
                VIEW_FEEDBACK_EVENT_CALLED: {
                  actions: 'openUsabilla',
                },
                GAMING_USER_DETAILS_FETCHED: {
                  actions: [
                    'updateUserTrackingInfo',
                    'saveInfoAccountInfo',
                    'trackPendingAccountEvents',
                  ],
                },
                VIEW_HAMBURGER_MENU_CLICK: {
                  actions: ['trackHamburgerClick', 'nav_HANDLE_CHANGE'],
                },
              },
            },
          },
        },
        headerProductNavigation: {
          initial: 'idle',
          states: {
            idle: {
              always: [
                {
                  target: 'on',
                  cond: 'isKrakenEnabled',
                },
                {
                  target: 'off',
                },
              ],
            },
            on: {
              invoke: {
                src: 'watchHeaderProductNavigationActions',
              },
              on: {
                VIEW_HEADER_PRODUCT_EVENT_CALLED: {
                  actions: [
                    'trackRedirectToProduct',
                    'initiateRedirectWithDelay',
                  ],
                },
                REDIRECT_TO_PRODUCT: {
                  actions: 'redirectToProductPage',
                },
              },
            },
            off: {},
          },
        },
        account: {
          initial: 'idle',
          states: {
            idle: {
              always: [
                {
                  target: 'on',
                  cond: 'isKrakenEnabled',
                },
                {
                  target: 'off',
                },
              ],
            },
            on: {
              invoke: {
                src: 'watchAccountActions',
              },
              on: {
                VIEW_PROMOTIONS_EVENT_CALLED: {
                  actions: 'openPromotionsPage',
                },
                APP_VISIBILITY_VISIBLE: {
                  actions: 'updateBalance',
                },
              },
            },
            off: {},
          },
        },
        cookieBanner: {
          initial: 'idle',
          states: {
            idle: {
              always: [
                {
                  target: 'on',
                  cond: 'isCookieBannerEnabled',
                },
                {
                  target: 'off',
                },
              ],
            },
            on: {
              invoke: {
                src: 'fetchCookieBannerInfo',
                onDone: [
                  {
                    target: 'visible',
                    cond: 'isCookieVisible',
                  },
                  {
                    actions: [
                      {
                        type: 'sendTrackEvents',
                      },
                      {
                        type: 'save',
                        data: { delayedTrackingAvailable: true },
                      },
                    ],
                    target: 'hidden',
                  },
                ],
              },
            },
            visible: {
              entry: {
                type: 'showLayoutComponent',
                data: 'CookieBanner',
              },
              on: {
                VIEW_COOKIE_BANNER_CLICK: {
                  target: 'accepted',
                },
                LAYOUT_CHANGE_END: {
                  target: 'visible',
                },
              },
            },
            hidden: {
              entry: [
                {
                  type: 'hideLayoutComponent',
                  data: 'CookieBanner',
                },
              ],
            },
            accepted: {
              entry: [
                {
                  type: 'setCookieBannerCookie',
                },
                {
                  type: 'sendTrackEvents',
                },
                {
                  type: 'save',
                  data: { delayedTrackingAvailable: true },
                },
                {
                  type: 'hideLayoutComponent',
                  data: 'CookieBanner',
                },
              ],
            },
            off: {},
          },
        },
        initializing: {
          initial: 'init',
          states: {
            init: {
              initial: 'initialisingConfig',
              states: {
                initialisingConfig: {
                  entry: 'handleOpenInIframe',
                  invoke: {
                    src: 'initialiseConfig',
                    onDone: {
                      target: 'initialisingFeatureFlags',
                    },
                    onError: {
                      target: 'initialisingFeatureFlags',
                    },
                  },
                },
                initialisingFeatureFlags: {
                  invoke: {
                    src: 'fetchFeatureFlagsConfig',
                    onDone: {
                      target: 'checkSegmentsCookie',
                      actions: [
                        {
                          type: 'save',
                          data: {
                            features: '$event.data',
                          },
                          meta: {
                            selectors: ['$action.data.features'],
                          },
                        },
                      ],
                    },
                  },
                },
                checkSegmentsCookie: {
                  invoke: {
                    src: 'fetchSegmentsCookie',
                    onDone: [
                      {
                        target: 'installingTracking',
                        actions: ['checkSegmentsCookie'],
                      },
                    ],
                  },
                },
                installingTracking: {
                  entry: ['installTracking'],
                  invoke: {
                    src: 'initializeTrackingData',
                    onDone: [
                      {
                        target: 'trackGamingRollout',
                        actions: 'saveInitialTrackingData',
                        cond: 'isRoutingEnabled',
                      },
                      {
                        target: 'fetchDeviceInfo',
                        actions: 'saveInitialTrackingData',
                      },
                    ],
                  },
                },
                trackGamingRollout: {
                  invoke: {
                    src: 'trackGamingRollout',
                    onDone: [
                      {
                        target: 'fetchDeviceInfo',
                      },
                    ],
                  },
                },
                fetchDeviceInfo: {
                  invoke: {
                    src: 'fetchDeviceInfo',
                    onDone: [
                      {
                        target: 'manageCallbackMode',
                        actions: [
                          {
                            type: 'save',
                            data: {
                              currentScreenSize:
                                '$event.data.currentScreenSize',
                              deviceInfo: '$event.data.deviceInfo',
                              isFullScreen: '$event.data.isFullScreen',
                            },
                            meta: {
                              selectors: [
                                '$action.data.deviceInfo',
                                '$action.data.currentScreenSize',
                                '$action.data.isFullScreen',
                              ],
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
                manageCallbackMode: {
                  entry: 'manageGameLaunchCallbackMode',
                  invoke: {
                    src: 'setCallbackModeForComponents',
                    onDone: {
                      target: 'fetchInitialPage',
                      actions: [
                        {
                          type: 'batchLayoutOperations',
                          data: '$event.data.updates',
                          meta: {
                            selectors: ['$action.data'],
                          },
                        },
                      ],
                    },
                  },
                },
                fetchInitialPage: {
                  invoke: {
                    src: 'fetchPageInfo',
                    onDone: [
                      {
                        target: 'displayPagePreloaded',
                        cond: 'isLayoutPreloadedAndNormalPage',
                        actions: [
                          'updateCurrentPagePath',
                          {
                            type: 'save',
                            data: {
                              navigationLinks: '$event.data.navigationLinks',
                              isSidebarInLayout:
                                '$event.data.isSidebarInLayout',
                              currentLayout: '$event.data.currentLayout',
                              mainLayoutPath: '$event.data.mainLayoutPath',
                              controllersData: '$event.data.controllersData',
                              initialRequest: '$event.data.initialRequest',
                              currentTablesIdList:
                                '$event.data.liveDealerTables',
                              personalizedBanners:
                                '$event.data.personalizedBanners',
                              currentPagePath: '$event.data.currentPagePath',
                              trackingData: '$event.data.trackingInfo',
                              seo: '$event.data.seo',
                              isErrorPage: '$event.data.isErrorPage',
                              changePageAction: '',
                            },
                            meta: {
                              selectors: [
                                '$action.data.navigationLinks',
                                '$action.data.isSidebarInLayout',
                                '$action.data.currentLayout',
                                '$action.data.mainLayoutPath',
                                '$action.data.controllersData',
                                '$action.data.initialRequest',
                                '$action.data.currentTablesIdList',
                                '$action.data.personalizedBanners',
                                '$action.data.currentPagePath',
                                '$action.data.trackingData',
                                '$action.data.seo',
                                '$action.data.isErrorPage',
                              ],
                            },
                          },
                          {
                            type: 'batchLayoutOperations',
                            data: [
                              {
                                type: 'setLayoutProperty',
                                data: {
                                  path:
                                    'components.ContentWrapper.properties.isSidebarInLayout',
                                  value: '$context.isSidebarInLayout',
                                },
                                meta: {
                                  selectors: ['$action.data.value'],
                                },
                              },
                              {
                                type: 'setLayoutProperty',
                                data: {
                                  path:
                                    'components.Layout.properties.deviceType',
                                  value: '$context.deviceInfo.deviceType',
                                },
                                meta: {
                                  selectors: ['$action.data.value'],
                                },
                              },
                              {
                                type: 'setLayoutProperty',
                                data: {
                                  path:
                                    'components.Layout.properties.deviceNative',
                                  value: '$context.deviceInfo.isNative',
                                },
                                meta: {
                                  selectors: ['$action.data.value'],
                                },
                              },
                              {
                                type: 'setLayoutProperty',
                                data: {
                                  path: 'components.Layout.properties.deviceOs',
                                  value: '$context.deviceInfo.deviceOs',
                                },
                                meta: {
                                  selectors: ['$action.data.value'],
                                },
                              },
                              {
                                type: 'setLayoutProperty',
                                data: {
                                  path:
                                    'components.Layout.properties.launchStrategies',
                                  value: '$context.gameLaunchStrategies',
                                },
                                meta: {
                                  selectors: ['$action.data.value'],
                                },
                              },
                              {
                                type: 'setLayoutProperty',
                                data: {
                                  path:
                                    'components.Modal.properties.componentVisible',
                                  value: '$context.isSidebarInLayout',
                                },
                                meta: {
                                  selectors: ['$action.data.value'],
                                },
                              },
                              {
                                type: 'setLayoutProperty',
                                data: {
                                  path:
                                    'components.BottomNavigation.properties.callbackMode',
                                  value: '$context.callbackMode',
                                },
                                meta: {
                                  selectors: ['$action.data.value'],
                                },
                              },
                              {
                                type: 'setLayoutProperty',
                                data: {
                                  path:
                                    'components.BottomNavigation.properties.loggedIn',
                                  value: '$context.user.loggedIn',
                                },
                                meta: {
                                  selectors: ['$action.data.value'],
                                },
                              },
                              {
                                type: 'setLayoutProperty',
                                data: {
                                  path:
                                    'components.StaticNavigation.properties.callbackMode',
                                  value: '$context.callbackMode',
                                },
                                meta: {
                                  selectors: ['$action.data.value'],
                                },
                              },
                              {
                                type: 'setLayoutProperty',
                                data: {
                                  path:
                                    'components.StaticNavigation.properties.loggedIn',
                                  value: '$context.user.loggedIn',
                                },
                                meta: {
                                  selectors: ['$action.data.value'],
                                },
                              },
                            ],
                          },
                          'updateSiteTrackingStorageInfo',
                          'trackPageChange',
                          'updateSeo',
                          'saveSegments',
                        ],
                      },
                      {
                        target: 'displayPagePreloaded',
                        cond: 'isLayoutPreloadedAndErrorPage',
                        actions: [
                          'updateCurrentPagePath',
                          {
                            type: 'save',
                            data: {
                              isErrorPage: '$event.data.isErrorPage',
                              initialRequest: '$event.data.initialRequest',
                            },
                            meta: {
                              selectors: [
                                '$action.data.isErrorPage',
                                '$action.data.initialRequest',
                              ],
                            },
                          },
                        ],
                      },
                      {
                        target: 'displayPage',
                        actions: [
                          'updateCurrentPagePath',
                          'updateSiteTrackingStorageInfo',
                          {
                            type: 'save',
                            data: {
                              initialRequest: '$event.data.initialRequest',
                            },
                            meta: {
                              selectors: ['$action.data.initialRequest'],
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
                displayPage: {
                  entry: [
                    {
                      type: 'save',
                      data: {
                        appInitialized: true,
                      },
                    },
                    'layout_changePageId',
                  ],
                },
                displayPagePreloaded: {
                  entry: [
                    {
                      type: 'save',
                      data: {
                        appInitialized: true,
                      },
                    },
                    {
                      cond: 'isModalVisibleOnBigScreen',
                      type: ['scrollTop', 'setBodyNonScrollable'],
                    },
                    'layout_notifyChangeEnd',
                  ],
                },
              },
            },
          },
        },
        screenSizeManager: {
          initial: 'idle',
          invoke: { src: 'watchScreenMode' },
          states: {
            idle: {
              on: {
                ENVIRONMENT_SCREEN_SIZE_CHANGED: [
                  {
                    cond: 'isPromotionsPage',
                    actions: [
                      'saveCurrentScreenSize',
                      'manageGameLaunchCallbackMode', //TODO It doesn't work. Does not update callbackMode inside LaunchStrategiesProvider context, which is in use
                      'layout_changePageId',
                      'layout_reload',
                      'setBodyScrollable',
                      'scrollTop',
                    ],
                  },
                  {
                    actions: [
                      'saveCurrentScreenSize',
                      'manageGameLaunchCallbackMode', //TODO It doesn't work. Does not update callbackMode inside LaunchStrategiesProvider context, which is in use
                      'layout_reload',
                      'setBodyScrollable',
                      'scrollTop',
                    ],
                    target: 'off',
                  },
                ],
              },
            },
            off: {
              invoke: {
                src: 'initializePersonalizedBannersWithContext',
                onDone: 'idle',
              },
            },
          },
        },
        fullScreenManager: {
          initial: 'idle',
          invoke: {
            src: 'watchFullScreenMode',
          },
          states: {
            idle: {
              on: {
                ENVIRONMENT_FULL_SCREEN_CHANGED: [
                  {
                    actions: [
                      'saveFullScreenMode',
                      {
                        type: 'setLayoutProperty',
                        data: {
                          path: 'components.GameModal.properties.isFullScreen',
                          value: '$context.isFullScreen',
                        },
                        meta: {
                          selectors: ['$action.data.value'],
                        },
                      },
                    ],
                  },
                ],
              },
            },
          },
        },
        globalListeners: {
          initial: 'idle',
          invoke: {
            src: 'watchRouteChange',
          },
          states: {
            idle: {
              on: {
                UPDATE_PAGE: {
                  target: 'waitForRouteChange',
                  actions: [
                    'updatePrevPageArray',
                    'updateCurrentPagePath',
                    'updateUrl',
                    'layout_changePageId',
                  ],
                },
                VIEW_HEADER_MENU_ITEM_CLICK: {
                  target: 'handlingNavigationItem',
                  actions: [
                    'handleSubnavigationScrollReset',
                    'trackMenuItemClick',
                  ],
                },
                VIEW_SIDE_MENU_ITEM_CLICK: [
                  {
                    target: 'handlingNavigationItem',
                    cond: 'isClickedItemInternal',
                    actions: 'trackSideItemClick',
                  },
                  {
                    actions: 'trackSideItemClick',
                  },
                ],
                VIEW_SIDE_MENU_GAME_INFO_CLICK: {
                  actions: [
                    {
                      type: 'save',
                      data: {
                        changePageAction: 'INFO',
                      },
                    },
                    'trackSideItemClick',
                  ],
                  target: 'handlingGameDetails',
                },
                VIEW_SIDE_MENU_COMMAND_CLICK: [
                  {
                    target: 'openingAccountItemModal',
                    cond: 'isClickedItemAccount',
                    actions: 'trackMainMenuItemClick',
                  },
                  {
                    actions: 'trackMainMenuItemClick',
                  },
                ],
                VIEW_CATEGORY_VIEW_ALL_CLICK: {
                  actions: [
                    {
                      type: 'save',
                      data: {
                        changePageAction: 'VIEW_ALL',
                      },
                    },
                    'setBodyScrollable', // Added because of "view all" link placed in sidebar recently played category
                    'scrollTop',
                  ],
                  target: 'handlingNavigationItem',
                },
                VIEW_CATEGORY_ROUTE_ITEM_CLICK: {
                  target: 'handlingNavigationItem',
                  actions: 'trackPromoClick',
                },
                VIEW_CATEGORY_LINK_ITEM_CLICK: {
                  actions: 'trackPromoClick',
                },
                VIEW_BOTTOM_MENU_ITEM_CLICK: [
                  {
                    target: 'handlingNavigationItem',
                    cond: 'isClickedItemInternal',
                    actions: ['trackBottomNavigationClick', 'scrollTop'],
                  },
                  {
                    actions: 'trackBottomNavigationClick',
                  },
                ],
                VIEW_BOTTOM_MENU_COMMAND_CLICK: [
                  {
                    target: 'handlingNavigationCommand',
                    cond: 'isClickedLeftSliderCommand',
                    actions: 'trackBottomNavigationClick',
                  },
                  {
                    actions: 'trackBottomNavigationClick',
                  },
                ],
                VIEW_ERROR_ITEM_CLICK: [
                  {
                    target: 'handlingErrorItem',
                    actions: [
                      {
                        type: 'save',
                        data: { isErrorPage: false, initialRequest: true },
                      },
                      'trackErrorItemClick',
                    ],
                    cond: 'isClickedItemInternal',
                  },
                  {
                    actions: [
                      { type: 'save', data: { initialRequest: true } },
                      'trackErrorItemClick',
                    ],
                  },
                ],
                VIEW_MAIN_MENU_ITEM_CLICK: [
                  {
                    target: 'handlingNavigationItem',
                    actions: ['trackMainMenuItemClick', 'scrollTop'],
                    cond: 'isClickedItemInternal',
                  },
                  {
                    target: 'openingAccountItemModal',
                    cond: 'isClickedItemAccount',
                    actions: 'trackMainMenuItemClick',
                  },
                  {
                    actions: 'trackMainMenuItemClick',
                  },
                ],
                VIEW_MAIN_MENU_CLOSE_CLICK: 'closeMainMenu',
                VIEW_HEADER_BACK_BUTTON_CLICK: 'handlingBackButtonClick',
                VIEW_BREADCRUMB_CLICK: 'handlingNavigationItem',
                VIEW_CATEGORY_GAME_TILE_INFO_CLICK: {
                  actions: [
                    {
                      type: 'save',
                      data: {
                        changePageAction: 'INFO',
                      },
                    },
                  ],
                  target: 'handlingGameDetails',
                },
                OPEN_GAME_DETAILS: 'handlingGameDetails',
                VIEW_SEARCH_WRAPPER_CLICK: 'handlingNavigationItem',
                OPEN_GAME_MODAL: {
                  target: 'waitForRouteChange',
                  actions: [
                    'updatePrevPageArray',
                    'updateCurrentPagePath',
                    'updateUrl',
                    'saveScrollPosition',
                    'layout_openGameModal',
                    'disableZoom',
                  ],
                },
                VIEW_CLOSE_GAME_MODAL_TRIGGER: 'chooseGameModalCloseMethod',
                VIEW_CLOSE_GAME_MODAL_THROUGH_GAME_FRAME: {
                  target: 'closeGameModalThroughGameFrame',
                  actions: ['enableZoom'],
                },
                VIEW_CLOSE_GAME_MODAL: {
                  target: 'closeGameModal',
                  actions: ['enableZoom'],
                },
                VIEW_OPEN_DEPOSIT_GAME_MODAL: 'openDeposit',
                VIEW_MODAL_OVERLAY_CLICK: 'closeSidebar',
                VIEW_STEP_ITEM_CLICK: {
                  actions: 'trackStepItemClick',
                },
                VIEW_BANNER_STANDALONE_ITEM_CLICK: {
                  actions: 'trackBannerStandaloneItemClick',
                },
                VIEW_CATEGORY_SHUFFLE_CLICK: {
                  actions: ['fetchShuffleGames', 'trackShuffleGamesClick'],
                },
                VIEW_SEARCH_DESKTOP_OVERLAY_CLICK: {
                  actions: 'goBack',
                },
                UPDATE_PROMOTIONS_URL: 'updatePromotionsUrl',
                SESSION_STATE_LOGGED_OUT: {
                  target: 'goingBackToPreviousPage',
                  cond: 'currentlyOnRecentlyPlayedPage',
                },
                NAV_HANDLE_CHANGE: [
                  {
                    target: 'handlingNavigationCommand',
                    cond: 'isClickedLeftSliderCommand',
                  },
                  {
                    target: 'handlingNavigationItem',
                  },
                ],
                ROUTE_CHANGED: 'reactOnRouteChange',
                GLOBAL_GOBACK: 'goingBackToPreviousPage',
              },
            },
            openingAccountItemModal: {
              invoke: {
                src: 'fetchAccountItemModal',
                onDone: {
                  target: 'idle',
                },
              },
            },
            waitForRouteChange: {
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'idle',
                  cond: 'isRoutingNotEnabled',
                },
                VIEW_CLOSE_GAME_MODAL: 'closeGameModal',
                LAYOUT_MODAL_CLOSE: {
                  target: 'idle',
                  cond: 'isRoutingNotEnabled',
                },
                ROUTE_CHANGED: 'idle',
              },
            },
            updatePromotionsUrl: {
              entry: 'updatePromotionsPath',
              always: 'waitForRouteChange',
            },
            closeSidebar: {
              invoke: {
                src: 'fetchPreviousPageInfo',
                data: {
                  sidebar: true,
                },
                onDone: {
                  target: 'waitForRouteChange',
                  actions: [
                    {
                      type: 'save',
                      data: {
                        previousPageArray: '$event.data.previousPageArray',
                        trackingData: {
                          page: '$context.trackingData.page',
                          sidebar: null,
                        },
                        seo: {
                          page: '$context.seo.page',
                          sidebar: null,
                        },
                      },
                      meta: {
                        selectors: [
                          '$action.data.previousPageArray',
                          '$action.data.trackingData.page',
                          '$action.data.seo.page',
                        ],
                      },
                    },
                    'updateUrl',
                    'updateCurrentPagePath',
                    'layout_closeSidebar',
                    'setBodyScrollable',
                  ],
                },
              },
            },
            openDeposit: {
              entry: 'openDeposit',
              always: 'idle',
            },
            chooseGameModalCloseMethod: {
              entry: 'chooseGameModalCloseMethod',
              always: 'idle',
            },
            closeGameModalThroughGameFrame: {
              entry: 'sendGameModalCloseToGameFrame',
              always: 'idle',
            },
            closeGameModal: {
              invoke: {
                src: 'fetchPreviousPageInfo',
                data: { isClosingGameModal: true },
                onDone: {
                  actions: [
                    'setBodyScrollable',
                    'setFullScreenOff',
                    'layout_closeGameModal',
                    'removeGameLaunchController',
                    'showBalance',
                    'updateBalance',
                    'updateCurrentPagePath',
                    'updateUrl',
                    'layout_changePageId',
                  ],
                  target: 'waitForRouteChange',
                },
              },
            },
            closeMainMenu: {
              entry: [
                {
                  type: 'batchLayoutOperations',
                  data: [
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Menu.properties.visible',
                        value: false,
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path:
                          'components.BottomNavigation.properties.activeCommandItem',
                        value: false,
                      },
                    },
                  ],
                },
              ],
              always: 'idle',
            },
            reactOnRouteChange: {
              invoke: {
                src: 'fetchPageInfo',
                onDone: [
                  {
                    actions: [
                      'setBodyScrollable',
                      'scrollTop',
                      'updateCurrentPagePath',
                      'showBalance',
                      'layout_closeGameModal',
                      'layout_changePageId',
                    ],
                    target: 'idle',
                  },
                ],
              },
            },
            handlingGameDetails: {
              entry: [
                'layout_exitChange',
                'resetPageAction',
                'updatePrevPageArray',
                'updateCurrentPagePath',
                'updateUrl',
                'layout_changePageId',
              ],
              always: 'waitForRouteChange',
            },
            handlingErrorItem: {
              entry: [
                'updatePrevPageArray',
                'updateCurrentPagePath',
                'resetPageAction',
                'updateUrl',
                'layout_changePageId',
              ],
              always: 'waitForRouteChange',
            },
            handlingNavigationItem: {
              entry: [
                'layout_exitChange',
                'updatePrevPageArray',
                'updateCurrentPagePath',
                'resetPageAction',
                'saveScrollPosition',
                'updateUrl',
                'layout_changePageId',
                {
                  type: 'batchLayoutOperations',
                  data: [
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Menu.properties.visible',
                        value: false,
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path:
                          'components.Navigation.properties.initialScrollValue',
                        value: '$context.subnavigationScrollPosition',
                      },

                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Navigation.properties.loggedIn',
                        value: '$context.user.loggedIn',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path:
                          'components.BottomNavigation.properties.activeCommandItem',
                        value: false,
                      },
                    },
                  ],
                },
              ],
              always: 'waitForRouteChange',
            },
            handlingNavigationCommand: {
              entry: [
                {
                  type: 'batchLayoutOperations',
                  data: [
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Menu.properties.visible',
                        value: true,
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path:
                          'components.BottomNavigation.properties.activeCommandItem',
                        value: true,
                      },
                    },
                  ],
                },
              ],
              always: 'idle',
            },
            handlingBackButtonClick: {
              always: [
                {
                  target: 'closingApp',
                  cond: 'currentlyOnNavigationItemPage',
                },
                {
                  target: 'goingBackToPreviousPage',
                },
              ],
            },
            goingBackToPreviousPage: {
              invoke: {
                src: 'fetchPreviousPageInfo',
                onDone: {
                  actions: [
                    {
                      type: 'save',
                      data: {
                        changePageAction: 'BACK',
                        previousPageArray: '$event.data.previousPageArray',
                      },
                      meta: {
                        selectors: ['$action.data.previousPageArray'],
                      },
                    },
                    'setBodyScrollable',
                    'updateCurrentPagePath',
                    'resetPageAction',
                    'updateUrl',
                    'layout_changePageId',
                  ],
                  target: 'waitForRouteChange',
                },
              },
            },
            closingApp: {
              entry: ['scrollTop', 'closeApplication'],
              always: 'idle',
            },
          },
        },
        trackingListener: {
          initial: 'idle',
          states: {
            idle: {
              on: {
                TRACK_PAGE_CHANGE: 'transient',
                ENVIROMENT_USER_ACTION_TRIGGERED: {
                  cond: 'delayedTrackingNotInstalled',
                  actions: [
                    {
                      type: 'sendTrackEvents',
                    },
                  ],
                },
              },
            },
            transient: {
              always: [
                {
                  target: 'waitingForSession',
                  cond: 'isSessionNotResolved',
                },
                { target: 'tracking' },
              ],
            },
            waitingForSession: {
              on: {
                SESSION_STATE_LOGGED_OUT: 'tracking',
                SESSION_STATE_LOGGED_IN: 'tracking',
              },
            },
            tracking: {
              entry: 'trackPageChange',
              always: 'idle',
            },
          },
        },
        headerManager: {
          initial: 'idle',
          states: {
            idle: {
              on: {
                LAYOUT_CHANGE_END: 'updateHeaderProperties',
              },
            },
            updateHeaderProperties: {
              invoke: {
                src: 'setHeaderProperties',
                onDone: {
                  target: 'idle',
                  actions: {
                    type: 'batchLayoutOperations',
                    data: '$event.data.updates',
                    meta: {
                      selectors: ['$action.data'],
                    },
                  },
                },
              },
            },
          },
        },
        navManager: {
          initial: 'idle',
          states: {
            idle: {
              on: {
                LAYOUT_PAGEID_CHANGE: 'updateNavComponents',
                LAYOUT_CHANGE_END: 'updateNavComponents',
                LAYOUT_MODAL_CLOSE: 'updateNavComponents',
              },
            },
            updateNavComponents: {
              always: {
                target: 'idle',
                actions: [
                  {
                    type: 'batchLayoutOperations',
                    data: [
                      {
                        type: 'setLayoutProperty',
                        data: {
                          path:
                            'components.BottomNavigation.properties.currentPagePath',
                          value: '$event.mainLayoutPath',
                        },
                        meta: {
                          selectors: ['$action.data.value'],
                        },
                      },
                      {
                        type: 'setLayoutProperty',
                        data: {
                          path:
                            'components.StaticNavigation.properties.currentPagePath',
                          value: '$event.mainLayoutPath',
                        },
                        meta: {
                          selectors: ['$action.data.value'],
                        },
                      },
                    ],
                  },
                ],
              },
            },
          },
        },
        layoutManager: {
          initial: 'idle',
          states: {
            idle: {
              on: {
                LAYOUT_SYSTEM_ERROR_PAGE_OPEN: 'openErrorPage',
                LAYOUT_PAGEID_CHANGE: 'switchingLayout',
                LAYOUT_RELOAD: 'scrollPositioning',
                LAYOUT_MODAL_CLOSE: 'closeSidebar',
                LAYOUT_GAME_MODAL_OPEN: 'openGameModal',
                LAYOUT_GAME_MODAL_CLOSE: 'closeGameModal',
              },
            },
            switchingLayout: {
              initial: 'active',
              states: {
                active: {
                  invoke: {
                    src: 'pageIdToLayoutChange',
                    onDone: {
                      target: '#root.main.layoutManager.scrollPositioning',
                      actions: [
                        {
                          type: 'save',
                          data: {
                            navigationLinks: '$event.data.navigationLinks',
                            isSidebarInLayout: '$event.data.isSidebarInLayout',
                            currentLayout: '$event.data.currentLayout',
                            pageTitle: '$event.data.pageTitle',
                            mainLayoutPath: '$event.data.mainLayoutPath',
                            controllersData: '$event.data.controllersData',
                            currentTablesIdList:
                              '$event.data.currentTablesIdList',
                            trackingData: '$event.data.trackingData',
                            seo: '$event.data.seo',
                            updates: '$event.data.updates',
                            initialRequest: false,
                            segments: '$event.data.segments',
                            personalizedBanners:
                              '$event.data.personalizedBanners',
                            gameLaunchStrategies:
                              '$event.data.gameLaunchStrategies',
                            gameCloseStrategies:
                              '$event.data.gameCloseStrategies',
                            isErrorPage: '$event.data.isErrorPage',
                            changePageAction: '',
                            personalizedBannersInitialized:
                              '$event.data.personalizedBannersInitialized',
                            searchBarComponent:
                              '$event.data.searchBarComponent',
                          },
                          meta: {
                            selectors: [
                              '$action.data.navigationLinks',
                              '$action.data.isSidebarInLayout',
                              '$action.data.currentLayout',
                              '$action.data.pageTitle',
                              '$action.data.mainLayoutPath',
                              '$action.data.controllersData',
                              '$action.data.currentTablesIdList',
                              '$action.data.trackingData',
                              '$action.data.seo',
                              '$action.data.updates',
                              '$action.data.segments',
                              '$action.data.personalizedBanners',
                              '$action.data.gameLaunchStrategies',
                              '$action.data.gameCloseStrategies',
                              '$action.data.isErrorPage',
                              '$action.data.personalizedBannersInitialized',
                              '$action.data.searchBarComponent',
                            ],
                          },
                        },
                        {
                          type: 'batchLayoutOperations',
                          data: '$event.data.updates',
                          meta: {
                            selectors: ['$action.data'],
                          },
                        },
                        {
                          type: 'batchLayoutOperations',
                          data: [
                            {
                              type: 'setLayoutProperty',
                              data: {
                                path:
                                  'components.ContentWrapper.properties.isSidebarInLayout',
                                value: '$context.isSidebarInLayout',
                              },
                              meta: {
                                selectors: ['$action.data.value'],
                              },
                            },
                            {
                              type: 'setLayoutProperty',
                              data: {
                                path:
                                  'components.Layout.properties.deviceNative',
                                value: '$context.deviceInfo.isNative',
                              },
                              meta: {
                                selectors: ['$action.data.value'],
                              },
                            },
                            {
                              type: 'setLayoutProperty',
                              data: {
                                path: 'components.Layout.properties.deviceType',
                                value: '$context.deviceInfo.deviceType',
                              },
                              meta: {
                                selectors: ['$action.data.value'],
                              },
                            },
                            {
                              type: 'setLayoutProperty',
                              data: {
                                path: 'components.Layout.properties.deviceOs',
                                value: '$context.deviceInfo.deviceOs',
                              },
                              meta: {
                                selectors: ['$action.data.value'],
                              },
                            },
                            {
                              type: 'setLayoutProperty',
                              data: {
                                path:
                                  'components.Layout.properties.launchStrategies',
                                value: '$context.gameLaunchStrategies',
                              },
                              meta: {
                                selectors: ['$action.data.value'],
                              },
                            },
                            {
                              type: 'setLayoutProperty',
                              data: {
                                path:
                                  'components.Modal.properties.componentVisible',
                                value: '$context.isSidebarInLayout',
                              },
                              meta: {
                                selectors: ['$action.data.value'],
                              },
                            },
                            {
                              type: 'setLayoutProperty',
                              data: {
                                path:
                                  'components.BottomNavigation.properties.callbackMode',
                                value: '$context.callbackMode',
                              },
                              meta: {
                                selectors: ['$action.data.value'],
                              },
                            },
                            {
                              type: 'setLayoutProperty',
                              data: {
                                path:
                                  'components.BottomNavigation.properties.loggedIn',
                                value: '$context.user.loggedIn',
                              },
                              meta: {
                                selectors: ['$action.data.value'],
                              },
                            },
                            {
                              type: 'setLayoutProperty',
                              data: {
                                path:
                                  'components.StaticNavigation.properties.callbackMode',
                                value: '$context.callbackMode',
                              },
                              meta: {
                                selectors: ['$action.data.value'],
                              },
                            },
                            {
                              type: 'setLayoutProperty',
                              data: {
                                path:
                                  'components.Layout.properties.callbackMode',
                                value: '$context.callbackMode',
                              },
                              meta: {
                                selectors: ['$action.data.value'],
                              },
                            },
                            {
                              type: 'setLayoutProperty',
                              data: {
                                path:
                                  'components.ProvidersFilter.properties.loggedIn',
                                value: '$context.user.loggedIn',
                              },
                              meta: {
                                selectors: ['$action.data.value'],
                              },
                            },
                          ],
                        },
                        'updateSiteTrackingStorageInfo',
                        'trackPageChange',
                        'updateSeo',
                        'saveSegments',
                      ],
                    },
                  },
                  on: {
                    LAYOUT_EXIT_CHANGE: { target: 'done' },
                  },
                },
                done: {
                  type: 'exit',
                },
              },
              exit: 'layout_notifyChangeEnd',
            },
            scrollPositioning: {
              always: [
                {
                  actions: ['restoreScrollPosition', 'clearScrollRestore'],
                  target: 'idle',
                  cond: 'requiresScrollRestore',
                },
                {
                  target: 'idle',
                  cond: 'isModalVisibleOnBigScreen',
                  actions: 'setBodyNonScrollable',
                },
                {
                  target: 'idle',
                  cond: 'isMobile',
                },
                {
                  actions: ['scrollTop'],
                  target: 'idle',
                },
              ],
            },
            closeSidebar: {
              entry: [
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: 'components.Modal.properties',
                    value: {
                      componentVisible: false,
                      backButtonVisible: false,
                    },
                  },
                },
                {
                  type: 'setLayoutProperty',
                  data: {
                    path: 'components.ContentWrapper.properties',
                    value: {
                      isSidebarInLayout: false,
                    },
                  },
                },
                {
                  type: 'save',
                  data: {
                    isSidebarInLayout: false,
                  },
                },
                'updateSiteTrackingStorageInfo',
                'tracking_changePage',
                'updateSeo',
                'layout_changePageId',
              ],
              always: 'idle',
            },
            openGameModal: {
              entry: [
                {
                  type: 'batchLayoutOperations',
                  data: [
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Modal.properties.componentVisible',
                        value: false,
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Layout.properties.gameModalOpen',
                        value: true,
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.GameModal.properties.visible',
                        value: true,
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                  ],
                },
                'clearSearch_trigger',
                'updateGameLaunchedTracking',
              ],
              always: 'idle',
            },
            closeGameModal: {
              entry: [
                {
                  type: 'save',
                  data: {
                    isGameModalForMobileOpened: false,
                  },
                },
                {
                  type: 'save',
                  data: {
                    changePageAction: 'BACK',
                  },
                },
                {
                  type: 'batchLayoutOperations',
                  data: [
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.GameModal.properties.visible',
                        value: false,
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Layout.properties.gameModalOpen',
                        value: false,
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.GameModal.properties.game',
                        value: {},
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                  ],
                },
                'resetGameLaunchedTracking',
              ],
              always: 'idle',
            },
            openErrorPage: {
              invoke: {
                src: 'getErrorPage',
                onDone: {
                  target: 'idle',
                  actions: [
                    {
                      type: 'batchLayoutOperations',
                      data: '$event.data.updates',
                      meta: {
                        selectors: ['$action.data'],
                      },
                    },
                  ],
                },
              },
            },
          },
        },
        personalizedBannerManager: {
          initial: 'off',
          states: {
            off: {
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'on',
                  cond: 'isPersonalizedBannerInKraken',
                },
              },
            },
            on: {
              type: 'parallel',
              states: {
                fetchingPersonalizedBanners: {
                  initial: 'watchPersonalizedBanners',
                  states: {
                    watchPersonalizedBanners: {
                      invoke: {
                        src: 'watchPersonalizedBanners',
                      },
                      on: {
                        PERSONALIZED_BANNERS_UPDATED: {
                          actions: [
                            'updatePersonalizedBanners',
                            'categories_reload',
                          ],
                        },
                      },
                    },
                  },
                  onDone: 'idle',
                },
                idle: {
                  on: {
                    LAYOUT_CHANGE_END: {
                      target: 'fetchingPersonalizedBanners',
                      cond: 'isPersonalizedBannerInKraken',
                    },
                  },
                },
              },
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'off',
                },
              },
            },
          },
        },
        categoriesController: {
          initial: 'off',
          states: {
            off: {
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'on',
                  cond: 'isControllerEnabled_categories',
                },
              },
            },
            on: {
              type: 'parallel',
              states: {
                layoutReloader: {
                  initial: 'reloading',
                  states: {
                    idle: {
                      on: {
                        RELOAD_CATEGORIES: 'reloading',
                      },
                    },
                    reloading: {
                      invoke: {
                        src: 'getCategoriesLayoutContent',
                        onDone: {
                          target: 'idle',
                          actions: [
                            {
                              type: 'batchLayoutOperations',
                              data: '$event.data.updates',
                              meta: {
                                selectors: ['$action.data'],
                              },
                            },
                          ],
                        },
                      },
                      on: {
                        RELOAD_CATEGORIES: 'reloading',
                      },
                    },
                  },
                },
                view_loaded: {
                  type: 'parallel',
                  states: {
                    fetchingData: {
                      initial: 'fetchingJackpots',
                      states: {
                        fetchingJackpots: {
                          invoke: {
                            src: 'fetchJackpots',
                            onDone: {
                              actions: ['updateJackpots', 'categories_reload'],
                              target: 'fetchingTables',
                            },
                          },
                        },
                        fetchingTables: {
                          invoke: {
                            src: 'fetchTableForPageGames',
                            onDone: {
                              actions: ['updateTables', 'categories_reload'],
                              target: 'fetchStrikeGoldData',
                            },
                          },
                        },
                        fetchStrikeGoldData: {
                          invoke: {
                            src: 'fetchStrikeGold',
                            onDone: {
                              actions: ['updateStrikeGoldData'],
                              target: 'fetchJackpotsV2',
                            },
                          },
                        },
                        fetchJackpotsV2: {
                          always: {
                            target: 'done',
                            actions: ['getJackpotsV2'],
                          },
                        },
                        done: {
                          type: 'parallel',
                          states: {
                            watchJackpots: {
                              invoke: [{ src: 'watchJackpots' }],
                              on: {
                                JACKPOTS_UPDATED: {
                                  actions: [
                                    'updateJackpots',
                                    'jackpotsComponents_reload',
                                  ],
                                },
                              },
                            },
                            watchViewLoadedInterval: {
                              invoke: [{ src: 'useInterval' }],
                              on: {
                                INTERVAL_60S: {
                                  actions: ['refetchStaleJackpotsV2'],
                                },
                              },
                            },
                            watchLiveTableGames: {
                              invoke: [{ src: 'watchLiveTableGames' }],
                              on: {
                                LIVE_TABLE_GAMES_UPDATED: {
                                  actions: [
                                    'updateTables',
                                    'categories_reload',
                                  ],
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                    idle: {
                      on: {
                        REFETCH_CATEGORIES: 'fetchingData',
                      },
                    },
                  },
                  onDone: 'idle',
                },
                idle: {
                  on: {
                    LAYOUT_CHANGE_END: {
                      cond: 'isControllerEnabled_categories',
                      actions: ['categories_refetch', 'categories_reload'],
                    },
                  },
                },
              },
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'off',
                  cond: 'isControllerDisabled_categories',
                },
              },
            },
          },
        },
        recentlyPlayedController: {
          initial: 'off',
          states: {
            off: {
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'on',
                  cond: 'isControllerEnabled_recentlyPlayed',
                },
              },
            },
            on: {
              initial: 'updatingRP',
              states: {
                idle: {
                  on: {
                    RP_RERENDER: 'updatingRP',
                    LAYOUT_CHANGE_END: {
                      cond: 'isControllerEnabled_recentlyPlayed',
                      target: 'checkRecentlyPlayedType',
                    },
                  },
                },
                checkRecentlyPlayedType: {
                  always: [
                    {
                      target: 'fetchRecentlyPlayed',
                      cond: 'shouldRefetchRecentlyPlayedForCategory',
                    },
                    {
                      target: 'updatingRP',
                    },
                  ],
                },
                fetchRecentlyPlayed: {
                  invoke: {
                    src: 'fetchRecentlyPlayedGames',
                    onDone: [
                      {
                        target: 'idle',
                        actions: ['initAuthTokenRefresh', 'updateRetryStatus'],
                        cond: 'isResponseInvalid_InternalAuthTokenVariant',
                      },
                      {
                        target: 'updatingRP',
                        actions: [
                          'updateRecentlyPlayedGames',
                          'getRecentlyPlayedJackpotV2',
                        ],
                      },
                    ],
                  },
                },
                updatingRP: {
                  invoke: {
                    src: 'fetchRecentlyPlayedContent',
                    onDone: {
                      target: 'updatedRp',
                      actions: {
                        type: 'batchLayoutOperations',
                        data: '$event.data.updates',
                        meta: {
                          selectors: ['$action.data'],
                        },
                      },
                    },
                  },
                },
                updatedRp: {
                  after: {
                    0: {
                      target: 'idle',
                      actions: {
                        type: 'save',
                        data: {
                          rpFirstLoad: false,
                        },
                      },
                    },
                  },
                },
              },
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'off',
                  cond: 'isControllerDisabled_recentlyPlayed',
                },
                RP_RERENDER: 'on',
              },
            },
          },
        },
        jackpotsComponentsController,
        bingoGamesController: {
          initial: 'controllerDisabled',
          states: {
            controllerDisabled: {
              on: {
                LAYOUT_CHANGE_END: {
                  cond: 'isControllerEnabled_bingoGames',
                  target: 'fetchingBingoGames',
                },
              },
            },
            controllerIdle: {
              on: {
                LAYOUT_CHANGE_END: {
                  cond: 'isControllerDisabled_bingoGames',
                  target: 'controllerDisabled',
                },
                FETCH_BINGO_GAMES: 'fetchingBingoGames',
                RENDER_BINGO_GAMES: 'renderingBingoGames',
              },
            },
            fetchingBingoGames: {
              invoke: {
                src: 'fetchBingoGames',
                onDone: [
                  {
                    actions: ['saveFetchedBingoGames', 'watchBingoGamesTimer'],
                    target: 'renderingBingoGames',
                  },
                ],
              },
            },
            renderingBingoGames: {
              invoke: {
                src: 'prepareBingoGamesContent',
                onDone: {
                  actions: [
                    {
                      type: 'batchLayoutOperations',
                      data: '$event.data.updates',
                      meta: {
                        selectors: ['$action.data'],
                      },
                    },
                  ],
                  target: 'controllerIdle',
                },
              },
            },
          },
        },
        splashPageWatcher: {
          initial: 'idle',
          states: {
            idle: {
              on: {
                LAYOUT_CHANGE_END: {
                  actions: ['removeSplashPage', 'disableSplashPage'],
                  cond: 'shouldRemoveSplashPage',
                },
              },
            },
          },
        },
        bingoGamesWatcher: {
          initial: 'idle',
          on: {
            WATCH_BINGO_GAMES_TIMER:
              'bingoGamesWatcher.watchingBingoGamesTimer',
          },
          states: {
            idle: {},
            watchingBingoGamesTimer: {
              invoke: { src: 'watchBingoGamesTimer' },
            },
          },
        },
        shuffleGamesController: {
          initial: 'controllerIdle',
          states: {
            controllerIdle: {
              on: {
                FETCH_SHUFFLE_GAMES: [
                  {
                    actions: ['getShuffleGame', 'categories_reload'],
                    cond: 'isShuffleGamesListAlreadyLoaded',
                    target: 'controllerIdle',
                  },
                  {
                    target: 'fetchingShuffleGames',
                  },
                ],
                SESSION_STATE_LOGGED_OUT: [
                  {
                    actions: 'clearShuffleGames',
                  },
                ],
              },
            },
            fetchingShuffleGames: {
              invoke: {
                src: 'fetchShuffleGames',
                onDone: [
                  {
                    actions: [
                      'saveFetchedShuffleGames',
                      'getShuffleGame',
                      'categories_reload',
                    ],
                    target: 'controllerIdle',
                    cond: 'isShuffleGamesListFetchedSuccessfully',
                  },
                  {
                    target: 'controllerIdle',
                  },
                ],
              },
            },
          },
        },
        searchController,
        promotionsController: {
          initial: 'off',
          states: {
            off: {
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'on',
                  cond: 'arePromotionsEnabled',
                },
              },
            },
            on: {
              entry: {
                type: 'batchLayoutOperations',
                data: [
                  {
                    type: 'setLayoutProperty',
                    data: {
                      path: 'components.Modal.properties.titleKey',
                      value: 'promotionTitle',
                    },
                  },
                ],
              },
              initial: 'initializingHeader',
              states: {
                initializingHeader: {
                  always: [
                    {
                      target: 'view_loaded',
                      cond: 'isHeaderInitialized',
                    },
                    {
                      target: 'waitingForHeader',
                    },
                  ],
                },
                waitingForHeader: {
                  invoke: {
                    src: 'waitForHeader',
                  },
                  on: {
                    WH_HEADER_INITIALIZED: 'view_loaded',
                    WH_HEADER_TIMEOUT: 'headerErrored',
                  },
                },
                view_loaded: {
                  invoke: {
                    src: 'watchPromotionsEvents',
                  },
                  initial: 'initializingPromotions',
                  states: {
                    initializingPromotions: {
                      invoke: {
                        src: 'initializePromotions',
                        onDone: [
                          {
                            target: 'locationChangingToDetails',
                            cond: 'isPromotionsDetailsPage',
                          },
                          {
                            target: 'locationChangingToList',
                          },
                        ],
                      },
                    },
                    locationChangingToDetails: {
                      entry: 'showPromotionDetails',
                      on: {
                        PROMOTION_DETAILS_DISPLAYED: {
                          actions: [
                            'promotions_updateUrl',
                            'tracking_changePage',
                            'updatePrevPageArray',
                            'updateCurrentPagePath',
                          ],
                          target: 'promotionsDetailsVisible',
                        },
                      },
                    },
                    locationChangingToList: {
                      entry: 'showPromotionsList',
                      always: 'promotionsListVisible',
                    },
                    promotionsListVisible: {
                      entry: {
                        type: 'setLayoutProperty',
                        data: {
                          path: 'components.Modal.properties.backButtonVisible',
                          value: false,
                        },
                      },
                      on: {
                        PROMOTION_DETAILS_DISPLAYED: {
                          actions: [
                            'promotions_updateUrl',
                            'tracking_changePage',
                            'updatePrevPageArray',
                            'updateCurrentPagePath',
                          ],
                          target: 'promotionsDetailsVisible',
                        },
                      },
                    },
                    promotionsDetailsVisible: {
                      entry: {
                        type: 'setLayoutProperty',
                        data: {
                          path: 'components.Modal.properties.backButtonVisible',
                          value: true,
                        },
                      },
                      on: {
                        PROMOTION_LIST_DISPLAYED: {
                          actions: [
                            'updatePrevPageArray',
                            'updateCurrentPagePath',
                            'promotions_updateUrl',
                            'tracking_changePage',
                          ],
                          target: 'promotionsListVisible',
                        },
                        VIEW_MODAL_BACK_BUTTON_CLICK: {
                          actions: ['showPromotionsList'],
                          target: 'goToPreviousPage',
                        },
                      },
                    },
                    goToPreviousPage: {
                      invoke: {
                        src: 'fetchPreviousPageInfo',
                        onDone: {
                          actions: [
                            {
                              type: 'save',
                              data: {
                                previousPageArray:
                                  '$event.data.previousPageArray',
                              },
                              meta: {
                                selectors: ['$action.data.previousPageArray'],
                              },
                            },
                            'updateCurrentPagePath',
                            'promotions_updateUrl',
                          ],
                          target: 'promotionsListVisible',
                        },
                      },
                    },
                  },
                },
                headerErrored: {
                  entry: {
                    type: 'setLayoutProperty',
                    data: {
                      path: 'components.PromotionsBasecamp.properties',
                      value: {
                        error: {
                          message: 'Error occured while loading Promotions',
                        },
                      },
                    },
                  },
                },
              },
              on: {
                LAYOUT_CHANGE_END: [
                  {
                    target: 'off',
                    cond: 'isControllerDisabled_promotions',
                  },
                  {
                    target: 'refreshing',
                  },
                ],
              },
            },
            refreshing: {
              always: 'on',
            },
          },
        },
        gameDetailsController: {
          initial: 'off',
          states: {
            off: {
              on: {
                LAYOUT_CHANGE_END: {
                  target: 'on',
                  cond: 'isControllerEnabled_gameDetails',
                },
              },
            },
            on: {
              entry: [
                'updateSiteTrackingStorageInfo',
                {
                  type: 'batchLayoutOperations',
                  data: [
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.Modal.properties.titleKey',
                        value: 'gameInfoTitle',
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.GameDetails.properties.callbackMode',
                        value: '$context.callbackMode',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.GameDetails.properties.loggedIn',
                        value: '$context.user.loggedIn',
                      },
                      meta: {
                        selectors: ['$action.data.value'],
                      },
                    },
                  ],
                },
                'scrollTop',
              ],
              on: {
                LAYOUT_CHANGE_END: [
                  {
                    target: 'off',
                    cond: 'isControllerDisabled_gameDetails',
                  },
                  {
                    target: 'refreshing',
                  },
                ],
                VIEW_MODAL_BACK_BUTTON_CLICK: {
                  actions: ['goBack'],
                  target: 'off',
                },
              },
            },
            refreshing: {
              always: 'on',
            },
          },
        },
        seoCopyVisibilityController: {
          initial: 'idle',
          states: {
            idle: {
              on: {
                LAYOUT_MODAL_CLOSE: {
                  target: 'showSeoCopy',
                },
                LAYOUT_CHANGE_END: {
                  target: 'hideSeoCopy',
                  cond: 'isGameDetailsPage',
                },
              },
            },
            showSeoCopy: {
              entry: [
                {
                  type: 'batchLayoutOperations',
                  data: [
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.copy.properties',
                        value: {
                          visible: true,
                        },
                      },
                    },
                  ],
                },
              ],
              always: 'idle',
            },
            hideSeoCopy: {
              entry: [
                {
                  type: 'batchLayoutOperations',
                  data: [
                    {
                      type: 'setLayoutProperty',
                      data: {
                        path: 'components.copy.properties',
                        value: {
                          visible: false,
                        },
                      },
                    },
                  ],
                },
              ],
              always: 'idle',
            },
          },
        },
      },
    },
  },
};

export default mainConfig;
